module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres4-2d61a4fe630c8e88fadbc1e60f6f0a13.jpg";